import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import css from "./SectionHead.module.css";

const SectionHead = React.forwardRef(
  (
    { title, titleId, count, as: Tag = "h2", className, children, ...rest },
    ref,
  ) => (
    <div ref={ref} className={clsx(css.root, className)} {...rest}>
      <Tag id={titleId} className={css.title}>
        {title}
      </Tag>
      {count && <span className={css.count}>{count}</span>}
      {children && <div className={css.actions}>{children}</div>}
    </div>
  ),
);

SectionHead.displayName = "SectionHead";

SectionHead.propTypes = {
  title: PropTypes.string.isRequired,
  titleId: PropTypes.string,
  count: PropTypes.node,
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default SectionHead;
